import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Empty, EmptyContent, EmptyDescription, EmptyHeader, EmptyTitle } from '@/components/ui/empty'

export default function DeliveryPage() {
  const navigate = useNavigate()
  return (
    <div className="min-h-screen flex bg-background p-4">
      <Empty className="w-full">
        <EmptyHeader>
          <EmptyTitle>Estación Delivery</EmptyTitle>
          <EmptyDescription>Esta estación está creada en routing, pero aún no tiene tablero KDS.</EmptyDescription>
        </EmptyHeader>
        <EmptyContent>
          <Button onClick={() => navigate('/station/cocina', { replace: true })}>Ir a Cocina</Button>
        </EmptyContent>
      </Empty>
    </div>
  )
}

